import React, { useEffect, useMemo, useRef, useState } from 'react';
import '../../styles/globals.css'
import { Box, Grid, Button, MobileStepper, Paper, Grow, Typography, Divider, LinearProgress, Fade, Link } from '@mui/material'

import { useTheme } from '@mui/material/styles';

import karmaStyles from '../../styles/KarmaPool.module.css'
import CauseCardComponent from './causes/CauseCardComponent';
import DashboardMenuHeaderComponent from './header/DashboardMenuHeaderComponent';
import DashboardLogoutFooterComponent from './footer/DashboardLogoutFooterComponent';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';
import CycleTimer from './cycles/CycleTimer';
import CycleAllocatedTokens from './cycles/CycleAllocatedTokens';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

import giveDirectlyLogo from '../../images/causes/give_directly.png';
import evidenceActionLogo from '../../images/causes/evidence_action.png';
import cleanAirTaskForceLogo from '../../images/causes/clean_air_task_force.png';
import coolEarthLogo from '../../images/causes/cool_earth.png';
import wildAnimalInitiativeLogo from '../../images/causes/wild_animal_initiative.png';
import msfLogo from '../../images/causes/msf.png';

function preloadImages(array) {
    if (!preloadImages.list) {
        preloadImages.list = [];
    }
    var list = preloadImages.list;
    for (var i = 0; i < array.length; i++) {
        var img = new Image();
        img.onload = function () {
            var index = list.indexOf(this);
            if (index !== -1) {
                // remove image from the array once it's loaded
                // for memory consumption reasons
                list.splice(index, 1);
            }
        }
        list.push(img);
        img.src = array[i];
    }
}

preloadImages([giveDirectlyLogo, evidenceActionLogo, cleanAirTaskForceLogo, coolEarthLogo, wildAnimalInitiativeLogo]);

function DashboardCausesNew() {

    const karmaContext = useKarmaPoolContext();

    useEffect(() => {
        karmaContext.causeManager.subscribeToCause("Give Directly");
        karmaContext.causeManager.subscribeToCause("Evidence Action");
        karmaContext.causeManager.subscribeToCause("Clean Air Task Force");
        karmaContext.causeManager.subscribeToCause("Cool Earth");
        karmaContext.causeManager.subscribeToCause("Wild Animal Initiative");
        karmaContext.causeManager.subscribeToCause("MSF");
    }, [])

    {/* state for active page */ }
    const [activePage, setActivePage] = React.useState("CAUSES");

    return (
        <>
            <Box className={karmaStyles.homepageBox2}>
                <DashboardMenuHeaderComponent
                    causesEnabled={true} />
            </Box>
            <Box className={karmaStyles.homepageBox3}>
                <Box width={"100%"} sx={{ display: "flex", justifyContent: "center", marginTop: "0.0rem", marginBottom: "0.5rem" }}>
                    <Box maxWidth={900}>
                        {activePage === "NONE" ? <PreCauseStepper karmaContext={karmaContext} setActivePage={setActivePage} />
                            : <CauseStepper karmaContext={karmaContext} setActivePage={setActivePage} />}
                    </Box>
                </Box>
            </Box>
        </>
    );
}

function PreCauseStepper(props) {
    return (
        <Box>
            <Box width={"100%"} sx={{ display: "flex", justifyContent: "center", marginTop: "0.0rem", marginBottom: "0.0rem" }}>
                <Paper
                    square
                    sx={{
                        justifyContent: "center",
                        bgcolor: 'rgba(221, 221, 221, 0.0)',
                        color: "whitesmoke",
                        maxWidth: "16rem",
                        width: "16rem",
                    }}>
                    <CycleTimer />
                </Paper>
            </Box>
            <Typography variant="body2" sx={{ color: "whitesmoke", textAlign: "center", marginTop: "1rem", marginBottom: "1rem" }}>
                <strong>£{props.karmaContext.local.cycle.gbpInCycle.toFixed(2)} </strong>
                {" "}in the current cycle
            </Typography>
            <CycleAllocatedTokens />
            <Button
                onClickCapture={() => { props.setActivePage("CAUSE_SELECT") }}
                variant="contained"
                color="info"
                sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "0.5rem", marginBottom: "0.0rem" }}>
                Select Causes
            </Button>
        </Box>
    );
}

function LinearProgressWithLabel(props) {

    const karmaContext = useKarmaPoolContext();

    const [gbpRaisedTotalForCause, setGbpRaisedTotalForCause] = useState(-1);

    const [gbpRaisedTotalForCauseDisplay, setGbpRaisedTotalForCauseDisplay] = useState(-1);

    useEffect(() => {
        setAmounts();
    }, [karmaContext.local]);

    function setAmounts() {
        let amount = ((karmaContext.causeManager.getCause(props.name)["gbpRaisedToCycleTotal"]));

        if (isNaN(amount)) {
            return;
        }

        if (gbpRaisedTotalForCauseDisplay === -1) {
            setGbpRaisedTotalForCauseDisplay(amount);
        }

        setGbpRaisedTotalForCause(amount);
    }

    useEffect(() => {
        let amount = ((karmaContext.causeManager.getCause(props.name)["gbpRaisedToCycleTotal"]));

        if (isNaN(amount)) {
            return;
        }

        setGbpRaisedTotalForCause(amount);
        setGbpRaisedTotalForCauseDisplay(amount);
    }, [props.name]);

    useEffect(() => {
        return lerpValues(gbpRaisedTotalForCause, gbpRaisedTotalForCauseDisplay, setGbpRaisedTotalForCauseDisplay);
    }, [gbpRaisedTotalForCause, gbpRaisedTotalForCauseDisplay]);


    function lerpValues(valueGet, valueDisplayGet, valueSet) {
        console.log("valueGet " + valueGet + " valueDisplayGet " + valueDisplayGet);
        if (valueGet === -1) {
            return;
        }

        const timer = setInterval(() => {
            if (valueDisplayGet === valueGet) {
                return;
            }

            let diff = valueGet - valueDisplayGet;

            if (Math.abs(diff) < 0.1) {
                valueSet(valueGet);
                return;
            }

            let lerp = diff * 0.1;

            console.log("lerp to " + (valueDisplayGet + lerp));
            valueSet(valueDisplayGet + lerp);
        }, 5);

        return () => clearInterval(timer);
    }

    return (
        <Box sx={{
            width: "100%", display: 'flex', alignItems: 'center', justifyContent: "center",
            marginBottom: "0.0rem",
            marginTop: "0.0rem"
        }}>
            < Box sx={{
                minWidth: '17.5rem', maxWidth: "24.5rem", width: "80%"
            }}>
                <Typography variant="body2" sx={{ color: "whitesmoke", textAlign: "center", marginTop: "1.0rem", marginBottom: "1.0rem" }}>
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "center", width: "100%", marginTop: "0.75rem" }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: "0rem", width: "80%" }}>
                        <LinearProgress variant="determinate" value={Math.min((gbpRaisedTotalForCauseDisplay / 5) * 100, 100)} sx={{ backgroundColor: "rgba(255,255,255,0.2)", width: "20%" }} />
                        <Box sx={{ display: "flex", justifyContent: "left", width: "20%", float: "center", marginLeft: "0.625rem" }}>
                            <Box sx={{ float: "left" }}>
                                <Typography variant="body2">
                                    {`${Math.min((gbpRaisedTotalForCauseDisplay / 5) * 100, 100).toFixed(0)}%`}
                                </Typography>
                            </Box>
                        </Box>
                        <Typography variant="body2" sx={{ color: "whitesmoke", textAlign: "center", marginTop: "0.0rem" }}>
                            threshold: £5.00
                        </Typography>
                    </Box>
                </Box>

                <Typography variant="body2" sx={{ color: "whitesmoke", textAlign: "center", marginTop: "1.0rem", marginBottom: "1.0rem" }}>
                    <strong>£{(gbpRaisedTotalForCauseDisplay).toFixed(2)}</strong> total for cause
                </Typography>

            </Box >
        </Box >
    );
}

function CauseStepper(props) {
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = 6;

    const karmaContext = useKarmaPoolContext();

    const handleNext = () => {
        if (activeStep === maxSteps - 1) {
            setActiveStep(0);
        }
        else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const handleBack = () => {
        if (activeStep === 0) {
            setActiveStep(maxSteps - 1);
        }
        else {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };

    function RenderCause1(setSelectedCauseName) {
        return RenderCause("Give Directly", "Give Directly", "Give directly to those in need.", giveDirectlyLogo, "https://www.givedirectly.org/", "", setSelectedCauseName);
    }

    function RenderCause2(setSelectedCauseName) {
        return RenderCause("Evidence Action", "Evidence Action", "Reduce human suffering.", evidenceActionLogo, "https://www.evidenceaction.org/", "", setSelectedCauseName);
    }

    function RenderCause3(setSelectedCauseName) {
        return RenderCause("Clean Air Task Force", "Clean Air Task Force", "Help clean the air.", cleanAirTaskForceLogo, "https://www.catf.us/", "", setSelectedCauseName);
    }

    function RenderCause4(setSelectedCauseName) {
        return RenderCause("Cool Earth", "Cool Earth", "Help tackle climate change.", coolEarthLogo, "https://www.coolearth.org/", "", setSelectedCauseName);
    }

    function RenderCause5(setSelectedCauseName) {
        return RenderCause("Wild Animal Initiative", "Wild Animal Initiative", "Protect biodiversity.", wildAnimalInitiativeLogo, "https://www.wildanimalinitiative.org/", "", setSelectedCauseName);
    }

    function RenderCause6(setSelectedCauseName) {
        return RenderCause("MSF", "MSF", "Humanitarian medical aid.", msfLogo, "https://www.msf.org/", "", setSelectedCauseName);
    }

    function RenderCauseOrder(setSelectedCauseMemo) {
        switch (activeStep) {
            case 0:
                return RenderCause1(setSelectedCauseName);
            case 1:
                return RenderCause2(setSelectedCauseName);
            case 2:
                return RenderCause6(setSelectedCauseName);
            case 3:
                return RenderCause3(setSelectedCauseName);
            case 4:
                return RenderCause4(setSelectedCauseName);
            case 5:
                return RenderCause5(setSelectedCauseName);
            default:
                return RenderCause1(setSelectedCauseName);
        }
    }

    const [firstTime, setFirstTime] = useState(false);

    // This useEffect runs only once when the component mounts
    useEffect(() => {
        // Delay by 0.1 seconds
        setTimeout(() => {
            setFirstTime(false);
        }, 600);
    }, []);


    function RenderCause(name, displayName, description, logo, url, lockKey, setSelectedCauseName) {

        if (firstTime) {
            return (
                <Grow in={true} key={displayName} timeout={440} style={{ transformOrigin: '0 1 1' }}>
                    {RenderCauseInner(name, displayName, description, logo, url, lockKey, setSelectedCauseName)}
                </Grow>
            );
        }

        return (
            <>
                <Fade in={true} key={displayName} timeout={550} style={{ transformOrigin: '0 1 1' }}>
                    {RenderCauseInner(name, displayName, description, logo, url, lockKey, setSelectedCauseName)}
                </Fade>
            </>
        );
    }

    function RenderCauseInner(name, displayName, description, logo, url, lockKey, setSelectedCauseName) {
        useEffect(() => {
            console.log("mounted RenderCauseInner");
            setSelectedCauseName(name);
        }, [displayName]);

        return (
            <Grid container justify="center" spacing={3} sx={{
                paddingLeft: "1.25rem",
                paddingRight: "1.25rem",
                paddingBottom: "0.0rem",
                paddingTop: "0.825rem",
            }}>
                <Grid item lg={12} md={12} xs={12} justifyContent="right">
                    <CauseCardComponent
                        name={name}
                        displayName={displayName}
                        description={description}
                        url={url}
                        allocatedTokens={0}
                        logo={logo}
                        tokenPercent={0}
                        justifyContent={"center"}
                    />
                </Grid>
            </Grid>
        );
    }

    const [selectedCauseName, setSelectedCauseName] = useState("Give Directly");

    function setSelectedCauseMemo(name) {
        setSelectedCauseName(name);
    }

    function getSelectedCauseName() {
        return selectedCauseName;
    }

    const [isMember, setIsMember] = useState(false);

    useEffect(() => {
        setIsMember(karmaContext.local.user.member);
    }, [karmaContext.local.user]);

    return (
        <Box sx={{ maxWidth: 450 }}>
            <Box sx={{ width: '100%', paddingTop: "0.0rem", marginBottom: "0.5rem" }}>
                <Box width={"100%"} sx={{ display: "flex", justifyContent: "center", marginTop: "0.0rem", marginBottom: "0.25rem" }}>
                    <Paper
                        square
                        sx={{
                            justifyContent: "center",
                            bgcolor: 'rgba(221, 221, 221, 0.0)',
                            color: "whitesmoke",
                            maxWidth: "24rem",
                            width: "24rem",
                        }}>
                        <CycleTimer variant={2} />
                    </Paper>
                </Box>
                {RenderCauseOrder(setSelectedCauseMemo)}
                <Paper square sx={{ marginTop: "1.5rem" }} />
                <CycleAllocatedTokens />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", marginTop: "0.925rem", marginBottom: "0.0rem" }}>
                <MobileStepper
                    variant="text"
                    steps={maxSteps}
                    position="static"
                    activeStep={activeStep}
                    sx={{
                        width: "14.5rem",
                        borderRadius: "0.25rem",
                        backgroundColor: "#020206",
                        color: "whitesmoke",
                    }}
                    nextButton={
                        <Button size="small" onClick={handleNext}>
                            Next
                            {theme.direction === 'rtl' ? (
                                <KeyboardArrowLeft />
                            ) : (
                                <KeyboardArrowRight />
                            )}
                        </Button>
                    }
                    backButton={
                        <Button size="small" onClick={handleBack}>
                            {theme.direction === 'rtl' ? (
                                <KeyboardArrowRight />
                            ) : (
                                <KeyboardArrowLeft />
                            )}
                            Back
                        </Button>
                    }
                />
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.875em", color: "whitesmoke", marginBottom: "0.75rem" }}>
                <Link href={"/karma/dashboard/cycle"}>
                </Link>
            </Typography>
            {/*<Box sx={{ display: "flex", justifyContent: "center", marginTop: "1.25rem", marginBottom: "0.0rem" }}>
                <a href={"/karma/dashboard/causes"} >
                    go back
                </a>
                </Box>*/}

        </Box>
    );
}

export default DashboardCausesNew;


